import React from "react";

//boostrap
import { Container, Row } from "reactstrap";

//components
import { FormRegisterDemo } from "@components/register";

function RequestDemoPage() {
  return (
    <div className="wrapper -registerPage">
      <div className="registerContainer">
        <Container className="bg-transparent shadow-none">
          <Row className="align-items-center">
            <FormRegisterDemo />
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default RequestDemoPage;